import React from 'react';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  tableBtnWrap: {
    display: 'flex',
    '&.horizontal': {
      justifyContent: 'space-around',
      '& > div': { marginRight: 5, '&:last-child': { marginRight: 0 } },
    },
    '&.vertical': {
      flexDirection: 'column',
      '& > div': { marginBottom: 5, '&:last-child': { marginBottom: 0 } },
    },
  },
}));

/**
 * 테이블 셀 내부에서 버튼을 여러가지 넣었을 때 위치를 잡아주는 컴포넌트
 * @param props
 * @returns {*}
 * @constructor
 */
const TableBtnWrap = (props) => {
  const classes = useStyles();
  const { direction = 'horizontal', children } = props;

  return (
    <div
      className={clsx(
        direction === 'horizontal' && 'horizontal',
        direction === 'vertical' && 'vertical',
        classes.tableBtnWrap
      )}
    >
      {children}
    </div>
  );
};

export default TableBtnWrap;
